import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";
import { formatMoney, STORE_CONFIG } from "../config/store";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page-container">
        <div className="breadcrumb">
          <Link onClick={toTop} to="/">
            Home
          </Link>{" "}
          &gt; <span>Shopping cart</span>
        </div>
        <div className="cart-page empty">
          <h1>Shopping cart</h1>
          <p>Your cart is currently empty.</p>
          <Link onClick={toTop} to="/" className="continue-shopping">
            Continue shopping
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page-container">
      <div className="breadcrumb">
        <Link onClick={toTop} to="/">
          Home
        </Link>{" "}
        &gt; <span>Shopping cart</span>
      </div>
      <div className="cart-page">
        <h1>Shopping cart</h1>

        <table className="cart-table">
          <thead>
            <tr>
              <th className="col-product">Product</th>
              <th className="col-price">Price</th>
              <th className="col-quantity">Quantity</th>
              <th className="col-total">Total</th>
            </tr>
          </thead>
          <tbody>
            {cartItems.map((item, index) => {
              const product = getProductById(item.id);
              if (!product) return null;

              const price = parseFloat(product.price.replace(/,/g, ""));
              const total = price * item.quantity;

              return (
                <tr key={`${item.id}-${item.size}-${item.color}-${index}`}>
                  <td className="col-product">
                    <div className="product-info">
                      <img src={product.image} alt={product.name} />
                      <div className="product-details">
                        <p>{product.name}</p>
                      </div>
                    </div>
                  </td>
                  <td className="col-price">{formatMoney(product.price)}</td>
                  <td className="col-quantity">
                    <div className="quantity-controls">
                      <button
                        onClick={() =>
                          handleUpdateQuantity(
                            item.id,
                            item.size,
                            item.color,
                            item.quantity - 1
                          )
                        }
                      >
                        -
                      </button>
                      <input type="text" value={item.quantity} readOnly />
                      <button
                        onClick={() =>
                          handleUpdateQuantity(
                            item.id,
                            item.size,
                            item.color,
                            item.quantity + 1
                          )
                        }
                      >
                        +
                      </button>
                    </div>
                    <button
                      className="remove-btn"
                      onClick={() =>
                        removeFromCart(item.id, item.size, item.color)
                      }
                    >
                      &#10005; Remove
                    </button>
                  </td>
                  <td className="col-total">{formatMoney(total)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <div className="cart-footer">
          <div className="cart-footer-left">
            <p className="taxes-info">
              Fixed shipping of {formatMoney(STORE_CONFIG.shippingFee)} is added at checkout. Any import charges are not included.
            </p>
          </div>
          <div className="cart-footer-right">
            <div className="subtotal">
              <span className="subtotal-label">Subtotal:</span>
              <span className="subtotal-amount">{formatMoney(subtotal)}</span>
            </div>
            <button className="checkout-btn" onClick={handleCheckout}>
              Check out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
